import { actionTypes } from './actions'
import { util } from '../../util'
import { dataModels } from '../../dataModels'

export const initialState = {
    count: 0,
    notification_loading: false,
    is_notification_update_success: false,
    modalClose: false,
    notifications_list: [],
    notifications_filter: dataModels.getInitialNotificationFilter(),
    notification_details: {},
    user_loading: false,
    pageNo: 1,
    size: 10,
    order: 'desc',
    orderBy: 'created',
    notification_error: '',
    fetch_notification_failed: false,
    is_editing_completed_pushNotification: false,
    isNotificationTitleUpdated: false,
    notification_update_message: '',
    dmaList: [],
}

const pushNotificationReducer = (state = initialState, action) => {
    const { type, payload } = action
    const { shallowHelper } = util

    switch (type) {
        case actionTypes.MODAL_OPEN: {
            return shallowHelper(state, { modalClose: false })
        }

        case actionTypes.MODAL_CLOSE: {
            return shallowHelper(state, { modalClose: true })
        }

        case actionTypes.FETCH_PUSH_NOTIFICATION_BY_ID_SUCCESS: {
            /** following update will trigger the push notification details page to re-render */
            return shallowHelper(state, {
                notification_loading: false,
                notification_details: payload,
                fetch_notification_failed: false,
            })
        }

        case actionTypes.FETCH_PUSH_NOTIFICATION_BY_ID_FAILED: {
            return shallowHelper(state, {
                notification_loading: false,
                fetch_notification_failed: true,
            })
        }

        case actionTypes.NOTIFICATION_LOADING_START: {
            return shallowHelper(state, {
                notification_loading: true,
            })
        }

        case actionTypes.NOTIFICATION_LOADING_END: {
            return shallowHelper(state, {
                notification_loading: false,
            })
        }

        case actionTypes.UPDATE_PUSH_NOTIFICATION_TITLE_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
                notification_loading: false,
                modalClose: true,
            })
        }

        case actionTypes.UPDATE_PUSH_NOTIFICATION_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
                notification_loading: false,
            })
        }

        case actionTypes.CLEAR_UPDATE_SUCCESS_ALERT: {
            return shallowHelper(state, {
                notification_update_message: '',
            })
        }

        case actionTypes.PUSH_NOTIFICATIONS_ERROR: {
            return shallowHelper(state, {
                pushNotification_error: payload,
                is_editing_completed_pushNotification: false,
            })
        }

        case actionTypes.FETCH_ALL_PUSH_NOTIFICATIONS_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
                notification_error: '',
                notification_loading: false,
            })
        }

        case actionTypes.CREATE_PUSH_NOTIFICATION_SUCCESS: {
            return shallowHelper(state, {
                notification_details: payload,
                notification_loading: false,
            })
        }

        case actionTypes.DISPLAY_UPDATE_SUCCESS_ALERT: {
            return shallowHelper(state, {
                notification_update_message: payload,
                is_notification_update_success: true,
            })
        }

        case actionTypes.UPDATE_NOTIFICATIONS_FILTER: {
            return shallowHelper(state, {
                notifications_filter: payload,
                user_loading: false,
            })
        }

        case actionTypes.CLEAR_NOTIFICATIONS_FILTER: {
            return shallowHelper(state, {
                notifications_filter: dataModels.getInitialNotificationFilter(),
            })
        }

        case actionTypes.USER_LOADING_START: {
            return shallowHelper(state, {
                user_loading: true,
            })
        }

        case actionTypes.USER_LOADING_END: {
            return shallowHelper(state, {
                user_loading: false,
            })
        }

        case actionTypes.TOGGLE_EDIT_TITLE_MODAL: {
            return shallowHelper(state, {
                isNotificationTitleUpdated: false,
            })
        }

        case actionTypes.FETCH_DMA_LIST_SUCCESS: {
            return shallowHelper(state, {
                dmaList: payload,
                notification_loading: false,
            })
        }

        default:
            return state
    }
}

export default pushNotificationReducer
